<template>
<v-container>
  <div style="">
        <!--パンくずリスト-->
    <v-breadcrumbs :items="breadcrumbs">
      <v-breadcrumbs-item
      exact
      slot="item"
      slot-scope="{ item }"
      :to="item.href"
      :disabled="showLink(item.href)">
        {{ item.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <ContactContent></ContactContent>
  </div>
  </v-container>
</template>

<script>
// お問い合わせ
import ContactContent from '../components/Contact/ContactContent'

export default {
  name: 'Contact',
  components: {
    ContactContent
  }
}
</script>
<script>
import ContactContent from '../components/Contact/ContactContent'
export default {
  name: 'Breadcrumbs',
  data: () => ({
    default: {
      name: '',
      href: ''
    },
    // パンくずリスト
    breadcrumbs: [
      {
        name: 'ホーム',
        href: '/'
      },
     {
        name: 'お問い合わせ',
        href: 'Contact'
      }
    ]
  }),
  methods: {
    // 現在のパス以外はリンクをつけない
    showLink (path) {
      var currentPath = this.$route.path
      if (path === currentPath) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    ContactContent
  }
}
</script>
